import { Component, ComponentFactoryResolver, OnInit, Self } from '@angular/core';
import * as Feather from 'feather-icons';
import { ServerService } from '../services/server.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';

import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
declare var iziToast: any;
import Swal from 'sweetalert2'
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { EditorModule } from '@progress/kendo-angular-editor';

declare var tinymce: any;
declare var $: any;
export interface Collobrator {
  email_name: string;
}
export interface EmailAddress {
  email_to: string;
}
@Component({
  selector: 'app-support-ticket-thread',
  templateUrl: './support-ticket-thread.component.html',
  styleUrls: ['./support-ticket-thread.component.css']
})
export class SupportTicketThreadComponent implements OnInit {

  datalist: any;
  replaymessage: any;
  files: any = [];
  value;
  conversation_show = false;
  filesend: any = [];
  param;
  param1;
  message;
  list;
  con = false;
  ticket;
  acess_token;
  customer_id;

  vigDAte:any;
  vigFromMail:any;
  sendChatMessageData: any;
  show_email_errors = false;
  emailFormControl;
  addSenderThread = [];//Send ID for forward thread
  signature_content;
  signature_title;
  ticket_replies;
  ticket_replies_all;
  tick_subject;
  ticket_created_by;
  tick_from;
  ticket_status_sel;
  ticket_status_perm;
  markspamshow = false;
  unmarkspamshow = false;
  ticket_delete_status = false;
  ticket_status;
  closed = false;
  first_res_time;
  closed_time;
  closed_by;
  Reopen_closed = false;
  admin_permission;
  first_letter;
  department;
  selectedDepart;
  selectedDepart_perm;
  ticket_agent;
  selectedAgentID;
  showmore_button = false;
  selectedAgentID_perm;

  tick_time;
  ticket_to;
  ticket_cc;
  own_mail;
  replied_from;
  mainCont;
  ticket_message_id;
  ticket_t;
  dept_list;
  total_offet;
  ticket_to_arr;
  status;
  reply_from_arr;
  ticket_id_orginal;
  agent_options;
  ticket_agent_name;
  ticket_agent_country;
  ticket_agent_priority;
  ticket_agent_requestType;

  ticket_agent_id
  collobrators: Collobrator[] = [];
  EmailToAddress: EmailAddress[] = [];
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  customer_profile;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  replytextmessage: FormGroup;
  ticket_media: any;
  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    const input = event.input;
    //     const input = event.input;
    // const value = event.value;
    // Add our fruit


    if (value) {
      this.collobrators.push({ email_name: value });
      event.value = "";
    }

    if (input) {
      input.value = '';
    }

    //  event.chipInput!.clear();
  }

  remove(collobrator: Collobrator): void {
    const index = this.collobrators.indexOf(collobrator);

    if (index >= 0) {
      this.collobrators.splice(index, 1);
    }
  }

  //CC Collabrator End
  addTo(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    const input = event.input;

    // Add our fruit
    if (value) {
      this.EmailToAddress.push({ email_to: value });
      console.log(this.EmailToAddress)
    }

    if (input) {
      input.value = '';
    }

    // event.chipInput!.clear();
  }

  removeTo(EmailAddress: EmailAddress): void {
    const index = this.EmailToAddress.indexOf(EmailAddress);

    if (index >= 0) {
      this.EmailToAddress.splice(index, 1);
    }
  }


  ext: RegExpExecArray;
  constructor(private router: Router, private serverService: ServerService, private route: ActivatedRoute, private _location: Location, private tinymce: EditorModule, private fb: FormBuilder) {
    this.param = this.route.snapshot.queryParamMap.get('id');


  }

  ngOnInit() {

    var profiles = localStorage.getItem('profile_image');
    if (profiles != '' && profiles != null && profiles != undefined && profiles != 'undefined' && profiles != 'null') {
      this.customer_profile = "https://erp.cal4care.com/cms_new/api_cms/v1.0/profile_image/" + profiles;
    } else {
      this.customer_profile = '';
    }
    // this.param1 = btoa(this.param);
    this.ticket_id_orginal = atob(this.param);
    this.param1 = atob(this.param);
    this.ticket_t = atob(this.param);
    console.log(this.param1);

    this.acess_token = localStorage.getItem('at');
    this.customer_id = localStorage.getItem('en');
    this.ticket_count();
    this.thred_view();
    this.initTiny();
    this.EmailToAddress = [];
    this.collobrators = [];
    this.replytextmessage = new FormGroup({
      'subject': new FormControl(null)
    });

  }


  ngAfterViewInit() {
    Feather.replace();

  }
  getShortName(fullName) {
    return fullName.substring(1, 0).toUpperCase();

  }
  showmore(show) {
    console.log(show)
    if (show == '0') {
      this.conversation_show = false;
      for (var i = 0; i < this.list.length; i++) {
        if (i <= 4) {
          this.list[i].show = false;
        } else {
          this.list[i].show = true;
        }
      }
    } else {
      this.conversation_show = true;
      for (var i = 0; i < this.list.length; i++) {

        this.list[i].show = false;

      }
    }

  }
  getFileExtension(filename) {
    // console.log(filename);
    // alert(filename);
    var ext = /^.+\.([^.]+)$/.exec(filename);
    // alert(ext);
    this.ext = ext;
    // console.log(this.ext);
    return ext == null ? "" : ext[1];
  }

  thred_view() {
    this.EmailToAddress = [];
    this.collobrators = [];
    Swal.fire('Please wait');
    Swal.showLoading();

    let customer_id: any = localStorage.getItem('en');
    let datas: any = new Object();
    let data_list: any = new Object();
    datas.action = 'omni_viewticket';
    // datas.customer_id = 'MzQ5';
    // datas.ticket_id = '65681';
    // data_list.access_token = 'OTA3IyMjOGRjMTBkYWRiMTFiN2M4Y2MxODI=';
    datas.customer_id = customer_id;
    datas.ticket_id = this.param1;
    data_list.access_token = this.acess_token;
    data_list.moduleType = 'ticket';
    data_list.operation = 'omniCurl';
    data_list.api_type = 'web';
    data_list.element_data = datas;



    //let api_req:any = '{"access_token":"OTA3IyMjOGRjMTBkYWRiMTFiN2M4Y2MxODI=","operation":"omniCurl","moduleType":"ticket","api_type":"web","element_data":{"action":"omni_viewticket","customer_id":"OTA3","ticket_id":"6341"}}';
    this.serverService.sendServer(data_list).subscribe((response: any) => {
      Swal.close();
      if (response.result.status == true) {

        this.ticket_replies = response.result.data;
        console.log(this.ticket_replies);


        this.ticket_replies_all = response.result.data;
        this.tick_subject = response.result.data[0].ticket_subject;
        this.ticket_agent_name = response.result.data[0].assigned_agent.ticket_assigned_to_agent;
        this.ticket_agent_id = response.result.data[0].assigned_agent.ticket_assigned_to_agent_id;
        this.ticket_agent_country = response.result.data[0].country_name;
        this.ticket_agent_priority = response.result.data[0].priority_name;
        this.ticket_agent_requestType = response.result.data[0].type_name;
    console.log('this.ticket_agent_name',this.ticket_agent_name);
        this.ticket_created_by = response.result.data[0].ticket_created_by;
        console.log(this.tick_subject)
        this.tick_from = response.result.data[0].ticket_from;
        this.ticket_status_sel = response.result.data[0].ticket_status_id;
        this.ticket_status_perm = response.result.data[0].ticket_status_id;

        this.ticket_status = response.result.data[0].status_desc;
        if (response.result.data[0].is_spam == '0') {
          this.unmarkspamshow = false;
          this.markspamshow = true;
        } else if (response.result.data[0].is_spam == '1') {
          this.unmarkspamshow = true;
          this.markspamshow = false;

        }
        this.ticket_delete_status = response.result.data[0].ticket_delete_status == '1' ? true : false;
        //   if(this.ticket_status_sel !=''){      
        //   this.get_agents_by_department_dup(this.ticket_status_sel)
        // }

        if (this.ticket_status == "Closed") {
          this.closed = true;
        } else {
          this.closed = false;
          if (response.closed_at == "" || response.closed_at == null) {

          } else {
            this.Reopen_closed = true;
          }
        }
        this.first_letter = response.result.data[0].first_letter;
        this.department = response.result.data[0].department_name;

        this.selectedDepart = response.result.data[0].depart_id;
        this.selectedDepart_perm = response.result.data[0].depart_id;
        // if (this.selectedDepart != '') {
        //   this.get_agents_by_department_dup(this.selectedDepart)
        // }


        // this.ticket_agent = response.result.data[0].ticket_assigned_to;
        this.ticket_agent = response.result.data[0].agent_name;

        // setTimeout(() => {
        this.selectedAgentID = response.result.data[0].ticket_assigned_to_id;
        // }, 4000);
        this.selectedAgentID_perm = response.result.data[0].ticket_assigned_to_id;
        // alert(this.selectedAgentID)

        this.tick_time = response.result.data[0].ticket_created_at;
        this.ticket_to = response.result.data[0].ticket_from;
        this.ticket_cc = response.result.data[0].mail_cc;
        this.own_mail = response.result.data[0].all_replied_to;
        this.replied_from = response.result.data[0].replied_from;
        this.mainCont = response.result.data[0].ticket_message;
        this.ticket_message_id = response.result.data[0].ticket_message_id;
        // this.ticket_t = atob(this.ticket_t);
        // this.status = response.status_options.filter(t => t.status_id != '9');
        // console.log(this.status);
        this.dept_list = response.departments;
        this.total_offet = response.total;
        this.reply_from_arr = response.result.data[0].replied_from.split(',');
        // this.ticket_to_arr = response.result.data[0].ticket_to.split(',');
        this.ticket_to_arr = response.result.data[0].ticket_to.split(',');
        console.log(this.own_mail)
        // if(this.ticket_to == this)
        // for(let i=0; i < this.ticket_to_arr.length; i++){
        //   console.log(this.ticket_to_arr[i])
        // }
        // var ticket_to_arr = response.result.data[0].ticket_to.split(',');

        if (this.ticket_to == response.result.data[0].own_mail) {
          // this.EmailToAddress.push({email_to:response.result.data[0].replied_from.split(',')});
          if (response.result.data[0].replied_from != 'null' && response.result.data[0].replied_from != '')
            for (var value in this.reply_from_arr) {
              this.EmailToAddress.push({ email_to: this.reply_from_arr[value] });
            }

        } else {

          // this.EmailToAddress.push({email_to:response.result.data[0].ticket_to});
          if (response.result.data[0].ticket_to != 'null' && response.result.data[0].ticket_to != '')
            for (var value in this.ticket_to_arr) {
              this.EmailToAddress.push({ email_to: this.ticket_to_arr[value] });
            }
        }



        console.log(this.EmailToAddress)


        if (response.total > 5) {
          this.showmore_button = true;

        }


        this.first_res_time = response.first_res_time;
        this.closed_time = response.closed_at;
        this.closed_by = response.ticket_closed_by;




      }
    },
      (error) => {
        console.log(error);
      });
  }
  thred_view1() {
    Swal.fire('Please wait');
    Swal.showLoading();
 
    this.EmailToAddress = [];
    this.collobrators = [];
    let customer_id: any = localStorage.getItem('en');
    let datas: any = new Object();
    let data_list: any = new Object();
    datas.action = 'omni_viewticket';
    // datas.customer_id = 'MzQ5';
    // datas.ticket_id = '65681';
    // data_list.access_token = 'OTA3IyMjOGRjMTBkYWRiMTFiN2M4Y2MxODI=';
    datas.customer_id = customer_id;
    datas.ticket_id = this.param1;
    data_list.access_token = this.acess_token;
    data_list.moduleType = 'ticket';
    data_list.operation = 'omniCurl';
    data_list.api_type = 'web';
    data_list.element_data = datas;



    //let api_req:any = '{"access_token":"OTA3IyMjOGRjMTBkYWRiMTFiN2M4Y2MxODI=","operation":"omniCurl","moduleType":"ticket","api_type":"web","element_data":{"action":"omni_viewticket","customer_id":"OTA3","ticket_id":"6341"}}';
    this.serverService.sendServer(data_list).subscribe((response: any) => {
      Swal.close();
      if (response.result.status == true) {
        Swal.close();

        this.ticket_replies = response.result.data;
        console.log(this.ticket_replies);
        this.ticket_replies_all = response.result.data;
        this.tick_subject = response.result.data[0].ticket_subject;
        this.ticket_agent_name = response.result.data[0].assigned_agent.ticket_assigned_to_agent;
        this.ticket_agent_id = response.result.data[0].assigned_agent.ticket_assigned_to_agent_id;
        this.ticket_agent_country = response.result.data[0].country_name;
        this.ticket_agent_priority = response.result.data[0].priority_name;
        this.ticket_agent_requestType = response.result.data[0].type_name;

        this.ticket_created_by = response.result.data[0].ticket_created_by;
        console.log(this.tick_subject)
        this.tick_from = response.result.data[0].ticket_from;
        this.ticket_status_sel = response.result.data[0].ticket_status_id;
        this.ticket_status_perm = response.result.data[0].ticket_status_id;

        this.ticket_status = response.result.data[0].status_desc;
        if (response.result.data[0].is_spam == '0') {
          this.unmarkspamshow = false;
          this.markspamshow = true;
        } else if (response.result.data[0].is_spam == '1') {
          this.unmarkspamshow = true;
          this.markspamshow = false;

        }
        this.ticket_delete_status = response.result.data[0].ticket_delete_status == '1' ? true : false;
        //   if(this.ticket_status_sel !=''){      
        //   this.get_agents_by_department_dup(this.ticket_status_sel)
        // }

        if (this.ticket_status == "Closed") {
          this.closed = true;
        } else {
          this.closed = false;
          if (response.closed_at == "" || response.closed_at == null) {

          } else {
            this.Reopen_closed = true;
          }
        }
        this.first_letter = response.result.data[0].first_letter;
        this.department = response.result.data[0].department_name;

        this.selectedDepart = response.result.data[0].depart_id;
        this.selectedDepart_perm = response.result.data[0].depart_id;
        // if (this.selectedDepart != '') {
        //   this.get_agents_by_department_dup(this.selectedDepart)
        // }


        // this.ticket_agent = response.result.data[0].ticket_assigned_to;
        this.ticket_agent = response.result.data[0].agent_name;

        // setTimeout(() => {
        this.selectedAgentID = response.result.data[0].ticket_assigned_to_id;
        // }, 4000);
        this.selectedAgentID_perm = response.result.data[0].ticket_assigned_to_id;
        // alert(this.selectedAgentID)

        this.tick_time = response.result.data[0].ticket_created_at;
        this.ticket_to = response.result.data[0].ticket_from;
        this.ticket_cc = response.result.data[0].mail_cc;
        this.own_mail = response.result.data[0].all_replied_to;
        this.replied_from = response.result.data[0].replied_from;
        this.mainCont = response.result.data[0].ticket_message;
        this.ticket_message_id = response.result.data[0].ticket_message_id;
        // this.ticket_t = atob(this.ticket_t);
        // this.status = response.status_options.filter(t => t.status_id != '9');
        // console.log(this.status);
        this.dept_list = response.departments;
        this.total_offet = response.total;
        this.reply_from_arr = response.result.data[0].replied_from.split(',');
        // this.ticket_to_arr = response.result.data[0].ticket_to.split(',');
        this.ticket_to_arr = response.result.data[0].ticket_to.split(',');
        console.log(this.own_mail)
        // if(this.ticket_to == this)
        // for(let i=0; i < this.ticket_to_arr.length; i++){
        //   console.log(this.ticket_to_arr[i])
        // }
        // var ticket_to_arr = response.result.data[0].ticket_to.split(',');

        if (this.ticket_to == response.result.data[0].own_mail) {
          // this.EmailToAddress.push({email_to:response.result.data[0].replied_from.split(',')});
          if (response.result.data[0].replied_from != 'null' && response.result.data[0].replied_from != '')
            for (var value in this.reply_from_arr) {
              this.EmailToAddress.push({ email_to: this.reply_from_arr[value] });
            }

        } else {

          // this.EmailToAddress.push({email_to:response.result.data[0].ticket_to});
          if (response.result.data[0].ticket_to != 'null' && response.result.data[0].ticket_to != '')
            for (var value in this.ticket_to_arr) {
              this.EmailToAddress.push({ email_to: this.ticket_to_arr[value] });
            }
        }



        console.log(this.EmailToAddress)


        if (response.total > 5) {
          this.showmore_button = true;

        }


        this.first_res_time = response.first_res_time;
        this.closed_time = response.closed_at;
        this.closed_by = response.ticket_closed_by;




      }
    },
      (error) => {
        Swal.close();
        console.log(error);
      });
  }
  replyOldticket() {
    Swal.fire('Please wait')
    Swal.showLoading()
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');
    const forms = new FormData();
    forms.append('name', this.datalist.ticket.user_name);
    forms.append('email', this.datalist.ticket.user_email.address);
    forms.append('ticket_number', this.datalist.ticket.ticket_number);
    forms.append('message', this.replaymessage.replace(/<(?:.|\n)*?>/gm, ' '));
    for (var i = 0; i < this.filesend.length; i++) {
      forms.append('attachment[' + i + ']', this.filesend[i]);
    }
    // forms.append('attachment', this.file);
    forms.append('action_info', 'reply_ticket');
    forms.append('action', 'reply_ticket');
    forms.append('operation', 'ticket');
    forms.append('access_token', access_token);
    forms.append('moduleType', 'ticket');
    forms.append('api_type', 'web');
    console.log(forms);
    var self = this;
    $.ajax({
      url: "https://cmsuat.cal4care.com/api_cms/v1.0/index_new.php",
      type: 'POST',
      data: forms,
      processData: false,  // tell jQuery not to process the data
      contentType: false,
      success: function (data) {

      }
    });

    setTimeout(() => {
      Swal.close();
      iziToast.success({
        message: "Ticket Replied Successfully",
        position: 'topRight'
      });
      this.files = [];
      this.filesend = [];
      this.file = null;
      this.replaymessage = "";
      this.ticket_count()
    }, 3000);

    // console.log(data)

  }

  // ticketthreadtimeout(){
  //   setTimeout (() => {
  //        // Swal.close();
  //   // iziToast.success({
  //   //                   message: "Ticket Replied Successfully",
  //   //                   position: 'topRight'
  //   //               });
  //       }, 3000);

  // }



  ticket_count() {
    Swal.fire('Please wait')
    Swal.showLoading()
    let datas: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');
    let tck_id: any = atob(localStorage.getItem('tck'));


    datas.action = "getTicketInfo";
    // datas.customer_id = customer_id;

    datas.ticket_id = tck_id;

    datasend.access_token = access_token;
    datasend.operation = "ticket";
    datasend.moduleType = "ticket";
    datasend.api_type = "web";
    datasend.element_data = datas;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      if (response && response.result.status == true) {
        Swal.close();


        if (response.result.data != null) {
          this.datalist = response.result.data;

          for (var i = 0; i < this.datalist.ticket.thread_entries.length; i++) {
            // if(i <= 4){
            if (i != null) {
              this.datalist.ticket.thread_entries[i].show = false;
              console.log(this.datalist.ticket.thread_entries[i].show);
            } else {
              this.datalist.ticket.thread_entries[i].show = true;
            }
          }

          console.log(this.datalist.ticket.thread_entries)
        } else {
          this.datalist = "";
        }

        // this.counts = response.counts

      }
      else {
        Swal.close();
        // this.counts={}

      }

    },
      (error) => {
        console.log(error);
      });

  }
  // filed: File;
  //  uploadFile(event:any) {
  //    this.filed = event.target.files[0];
  //    // console.log(event.target.files[0])
  //    for (let index = 0; index < event.length; index++) {
  //      const element = event[index];
  //      this.files.push(element.names)
  //    }  
  //  }
  localUrl;
  file: File;
  uploadFiless(event) {
    console.log(event[0])
    this.file = event[0];
    if (event[0] != undefined) {
      this.filesend.push(event[0])

    }

    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      this.files.push(element.name);
    }
    console.log(this.filesend)

  }



  uploadFile(event: any) {
    this.file = event.target.files[0];

    console.log(this.file)
    if (this.file != undefined) {

      this.filesend.push(this.file)
    }
    var events = event.target.files;
    for (let index = 0; index < events.length; index++) {
      const element = events[index];
      this.files.push(element.name)
    }

    console.log(this.filesend)

  }


  deleteAttachment(i) {
    this.files.splice(i, 1);
    this.filesend.splice(i, 1);
  }


  clickDiscard(id) {

    $('#replyPanelall_' + id).hide();
    // let reply_message_{{this.ticket_t}}s
    //  tinymce.activeEditor.setContent('');
    //  tinymce.get('reply_message_'+ id+'s').setContent('');
    tinymce.get('richTextAreaReply').setContent('');

  }

  get_agents_by_department() {

  }


  UpdateTicketStatus() {
  }

  AddNote() {
  }

  sendFullThread() {
  }

  clearEmailform() {
    this.emailFormControl = new FormControl({ value: '' });
    this.addSenderThread = [];
  }


  toggleClassreplyall(id) {
    console.log(id);
    tinymce.get('richTextAreaReply').setContent('');
    var x = document.getElementById("replyPanelall_" + id);
    // var y = document.getElementById("replyPanel_"+id);
    // y.style.display = "none";
    //  $('#'+y).hide();
    // alert(x);
    $('#replyPanelall_' + id).show();

    // if (x.style.display === "none") {
    //   x.style.display = "block";
    // } else {
    //   x.style.display = "none";
    // }

  }

  backtoPage() {
    this._location.back();
  }

  initTiny() {
    var richTextArea_id = 'richTextAreaReply';
    tinymce.init({
      selector: '#richTextAreaReply',
      height: 500,
      plugins: 'advlist autolink textcolor formatpainter lists link  image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste  wordcount autolink lists media table',
      toolbar: 'undo redo |fullscreen|forecolor backcolor| formatselect | bold italic | \ undo redo | link image file| code | \
       alignleft aligncenter alignright alignjustify | \
       bullist numlist outdent indent | autoresize',
      paste_data_images: true,
      images_upload_url: 'upload.php',
      automatic_uploads: false,
      default_link_target: "_blank",
      extended_valid_elements: "a[href|target=_blank]",
      link_assume_external_targets: true,
      images_upload_handler: function (blobInfo, success, failure) {
        var xhr, formData;

        xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.open('POST', 'upload.php');

        xhr.onload = function () {
          var json;

          if (xhr.status != 200) {
            failure('HTTP Error: ' + xhr.status);
            return;
          }

          json = JSON.parse(xhr.responseText);

          if (!json || typeof json.file_path != 'string') {
            failure('Invalid JSON: ' + xhr.responseText);
            return;
          }

          success(json.file_path);
        };

        formData = new FormData();
        formData.append('file', blobInfo.blob(), blobInfo.filename());

        xhr.send(formData);
      },
    });
    if (tinymce.editors.length > 0) {
      //  tinymce.execCommand('mceFocus', true, richTextArea_id );       
      tinymce.execCommand('mceRemoveEditor', true, richTextArea_id);
      tinymce.execCommand('mceAddEditor', true, richTextArea_id);
    }
  }

  onMessageSend($event) {
    if ($event.keyCode != '') {

      // alert('1212')
      this.sendChatMessageData();
      $event.stopPropagation();
      return false;
    }


  }
  getFields(input, field) {
    var output = [];
    for (var i = 0; i < input.length; ++i)
      output.push(input[i][field]);
    return output.toString();
  }


  replyMessage(msg_id, to, extra) {

    var formData = new FormData();
    var id = msg_id;
    // var fileName = $('#up_files_'+msg_id).val();
    // alert(fileName); return false;

    Swal.fire('Please wait')
    Swal.showLoading()


    msg_id = msg_id + extra;
    console.log(msg_id)
    // alert(msg_id);
    // if ((<HTMLInputElement>document.getElementById('up_files')).value != null) {
    //   var totalfiles = (<HTMLInputElement>document.getElementById('up_files')).files.length;
    //   for (var index = 0; index < totalfiles; index++) {
    //     formData.append("up_files[]", (<HTMLInputElement>document.getElementById('up_files')).files[index]);
    //   }
    // }

    // var to = $('#email_address_'+msg_id).val();
    // var cc = $('#mail_cc_'+msg_id).val();
    let sign = $('#singature_id').val();
    // alert(sign);
    var result_cc = this.getFields(this.collobrators, "email_name");
    var result_to = this.getFields(this.EmailToAddress, "email_to");
    var msg_id = tinymce.get('richTextAreaReply').getContent();
    //var msg_id = $('#editor').val();
    // var msg_id = $('#reply_message_'+msg_id).val();
    // tinymce.activeEditor.setContent('sdsdsd');
    // alert('1');

    // var msg_id = tinymce.get('reply_message_' + msg_id).getContent();


    // alert(myContent);

    // var myContent = tinymce.get("myTextarea").getContent();
    // alert(to1);
    // return false;
    if (msg_id == '' || msg_id == undefined) {
      iziToast.error({
        message: "Please Enter the Message",
        position: 'topRight'
      });
      return false;
    }
    if (result_to == '' || result_to == undefined) {
      iziToast.error({
        message: "Please Enter To Address ",
        position: 'topRight'
      });
      return false;
    }
    var self = this;
    formData.append('ticket_id', id);
    formData.append('to', result_to);
    formData.append("name", localStorage.getItem('cn'));
    formData.append('subject', this.tick_subject);
    formData.append("message", msg_id);
    formData.append("from", this.ticket_to);
    // formData.append("user_id", "64");
    // formData.append("signature_id", "97");
    formData.append("mail_cc", result_cc);
    formData.append("customer_id", this.customer_id);
    for (var i = 0; i < this.filesend.length; i++) {
      formData.append('attachment[' + i + ']', this.filesend[i]);
    }
    formData.append("action", "replyTicketMessage");

    formData.append("operation", "ticket");
    formData.append("moduleType", "ticket");
    formData.append("api_type", "web");

    console.log(formData)
    var self = this;
    $.ajax({
      url: "https://erp.cal4care.com/cms_new/api_cms/v1.0/index_new.php",
      type: 'POST',
      data: formData,
      processData: false,  // tell jQuery not to process the data
      contentType: false,
      success: function (data) {
        var d = JSON.parse(data);
        console.log(data);
        console.log(d);
        if(d.status=="true"){
          var str = new Date().setSeconds(0,0);
        var dt = new Date(str).toISOString();
        var str1=new Date().toUTCString();;
        console.log("dt",dt);
        console.log("dt-str1",str1);
          localStorage.setItem('fROM_mail',this.ticket_to);
          localStorage.setItem('msg',msg_id);
          localStorage.setItem('date',str1);

          self.vigDAte=(localStorage.getItem('date'));
          self.vigFromMail=(localStorage.getItem('fROM_mail'));
      
          $('#replyPanelall_' + id).hide();
          Swal.close();
          iziToast.success({
            message: "Ticket Replied Successfully",
            position: 'topRight'
          });
          self.files = [];
          self.filesend = [];
          self.file = null;
          self.replaymessage = "";
          setTimeout(() => {
            self.thred_view1();
            // self.thred_view();
          }, 100);
          
        }
        
        // setTimeout(() => {
         
        // }, 3000);
      }
      
    });


    


  }
  changeMyStatus(ticket_id) {
    //alert(ticket_id);
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Reopen it!',
      // inputValue: val,
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          html:
            '<div style="display: flex;justify-content: center;"><div class="pong-loader"></div></div>',
          showCloseButton: false,
          showCancelButton: false,
          showConfirmButton: false,
          focusConfirm: false,
          background: 'transparent',


        });
        Swal.fire('Please wait');
        Swal.showLoading();
        let api_req: any = '{"operation":"omniCurl","moduleType":"ticket","api_type":"web","access_token":"' + this.acess_token + '","element_data":{"ticket_id":"' + ticket_id + '","ticket_status":"9","action":"cms_reopen_tickets"}}';
        this.serverService.sendServer(api_req).subscribe((response: any) => {
          console.log(response)
          Swal.close();
          if (response.result.status == true) {
            iziToast.success({
              message: "Ticket Reopened Successfully",
              position: 'topRight'
            });
            this.thred_view();
          } else {

          }
        },
          (error) => {
            console.log(error);
          });
      }
    })
  }

  changeMyStatus1() {
    var tickto;
    if (this.ticket_to == this.own_mail) {
      tickto = this.replied_from;
    } else {
      tickto = this.ticket_to;
    }

    let customer_id: any = localStorage.getItem('en');

    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, close it!',
      // inputValue: val,
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          html:
            '<div style="display: flex;justify-content: center;"><div class="pong-loader"></div></div>',
          showCloseButton: false,
          showCancelButton: false,
          showConfirmButton: false,
          focusConfirm: false,
          background: 'transparent',


        });
        let api_req: any = new Object;
        let post_req: any = new Object();
        api_req.operation = "ticket";
        api_req.moduleType = "ticket";
        api_req.api_type = "web";
        api_req.access_token = localStorage.getItem('access_token');
        // post_req.admin_id = this.admin_id;
        post_req.user_id = customer_id;
        post_req.action = "oncloseTocket";
        post_req.status_id = "9";
        post_req.alert_status = result.value;
        post_req.ticket_id = this.ticket_t;
        post_req.ticket_to = tickto;
        post_req.ticket_cc = this.ticket_cc;
        api_req.element_data = post_req;


        this.serverService.sendServer(api_req).subscribe((response: any) => {
          Swal.close();
          if (response.status == true) {
            Swal.fire(
              'Closed!',
              'success'
            );
            this.backtoPage();
            // this.closed = true;
            // this.ticket_t = btoa(this.ticket_t);
            // this.getTicketDetails(this.ticket_t);
            // this.EmailToAddress = [];
            // this.collobrators = [];
          }
        },
          (error) => {
            console.log(error);
          });
      }
    })
  }



}
